const typography = {
  fontFamily: "Euclid Circular B SemiBold",
  h1: {
    // fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    fontWeight: 300,
    fontSize: "6rem",
    lineHeight: 1.167,
    letterSpacing: "-0.01562em",
  },
  h2: {
    // ontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    fontWeight: 300,
    fontSize: "3.75rem",
    lineHeight: 1.2,
    letterSpacing: "-0.00833em",
  },
  h3: {
    // fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    fontWeight: 400,
    fontSize: "3rem",
    lineHeight: 1.167,
    letterSpacing: "0em",
  },
  h4: {
    // fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    fontWeight: 400,
    fontSize: "2.125rem",
    lineHeight: 1.235,
    letterSpacing: "0.00735em",
  },
  h5: {
    fontFamily:
      '"Euclid Circular B", "Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 600,
    fontStyle: "normal",
    fontSize: "1.25rem",
    lineHeight: 1,
    letterSpacing: "0em",
  },
  h6: {
    fontFamily:
      '"Euclid Circular B", "Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 600,
    fontStyle: "normal",
    fontSize: "1.25rem",
    lineHeight: 1,
    letterSpacing: "0em",
  },
  subtitle1: {
    fontFamily:
      '"Euclid Circular B", "Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    fontSize: "0.875rem",
    lineHeight: 1.5,
    letterSpacing: "0em",
    fontStyle: "normal",
  },
  subtitle2: {
    // fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif"',
    fontWeight: 500,
    fontSize: "0.875rem",
    lineHeight: 1.57,
    letterSpacing: "0.00714em",
  },
  body1: {
    fontFamily:
      '"Euclid Circular B", "Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    fontSize: "1rem",
    // bumped from 1 → 1.5 so multi-line body text is not clipped/cramped
    lineHeight: 1.5,
    letterSpacing: "0em",
    fontStyle: "normal",
  },

  body2: {
    fontFamily:
      '"Euclid Circular B", "Roboto", "Helvetica", "Arial", sans-serif',
    // bumped from 300 → 400; weight 300 rendered as low-contrast/too-light text
    fontWeight: 400,
    fontSize: "0.875rem",
    lineHeight: 1.5,
    letterSpacing: "0.01071em",
  },
  button: {
    // fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    fontWeight: 400,
    fontSize: "0.875rem",
    lineHeight: 1.75,
    letterSpacing: "0.02857em",
    textTransform: "uppercase",
  },
};

export default typography;
